'use strict';

import mergeOpts from './merge-opts';
import {fd} from './promise-fastdom';

let anchorPromise = null;

/**
 * This utility toggles a class depending on window scroll position.
 * This mainly allows to change a header appearance when scrolling the page down.
 *
 * @param opts
 *  - threshold: On if window.scrollY is greater than threshold, Off otherwise
 */
export default function Scrolled(opts) {

    const o = mergeOpts({
        class: 'scrolled',
        threshold: '120px',
        element: document.documentElement,
    }, opts);

    if (!anchorPromise) {
        anchorPromise = fd.mutate(() => {
            const node = document.createElement('div');
            node.style.position = 'absolute';
            node.style.top = 0;
            document.body.appendChild(node);
            return node;
        });
    }

    this.observer = new IntersectionObserver(events => {
        return fd.mutate(() => {
            o.element.classList.toggle(`${o.class}-on`, !events[0].isIntersecting);
            o.element.classList.toggle(`${o.class}-off`, events[0].isIntersecting);
        });
    }, {rootMargin: `${o.threshold} 0px 0px 0px`,});
}

Scrolled.prototype.observe = function () {
    anchorPromise.then(anchor => this.observer.observe(anchor));
};

Scrolled.prototype.unobserve = function () {
    anchorPromise.then(anchor => this.observer.unobserve(anchor));
};

Scrolled.prototype.destroy = function () {
    this.observer.destroy();
}
